import React, { FC } from "react";
import { observer } from 'mobx-react-lite';
import { SequenceReferenceTreeNodeLabel, TreeNode, TreeNodeLabel } from '../TreeNode';
import { InstructionNodeProps } from './InstructionNodeFactory';
import { LoopInstruction } from '../../../../../machinelogic/types';

interface LoopInstructionProps extends InstructionNodeProps {
  instruction: LoopInstruction;
}

const getInstructionLabelName = (instruction: LoopInstruction): string => {
  switch (instruction.name) {
    case 'forever': return `Loop Forever`;
    case 'count': return `Loop ${instruction.parameters.count} times`;
    case 'while': return `Loop While ${instruction.parameters.conditionExpression}`;
  }
};

export const LoopNode: FC<LoopInstructionProps> = observer(({instruction, titleClassName = '', isSelected, isInvalid, onClick}) => {

  const instructionLabel = <TreeNodeLabel
    icon="icon-loop"
    name={getInstructionLabelName(instruction)}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode
      title={instructionLabel}
    >
      {
        <TreeNode
          title={
            <SequenceReferenceTreeNodeLabel
              name={instruction.parameters.sequenceName}
              onClick={onClick}
              sequenceName={instruction.parameters.sequenceName}
            />
          }
          titleClassName={titleClassName}
        />
      }
    </TreeNode>
  );
});
